<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/wo/pause/record/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item required :label="$t('shebeimingcheng')">
            <yi_data_select multiple type="equipment" :ids.sync="yt.conditions.equipmentIds"></yi_data_select>
          </el-form-item>
          <el-form-item required :label="$t('zantingshijian')">
            <yi_time_input type="datetimerange" :is_current="false" :start.sync="yt.conditions.pauseStartTime" :end.sync="yt.conditions.pauseEndTime" format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('xuanzeriqiheshijian')"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <!-- <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button> -->
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_report_equipment_pause_time_list',
  data() {
    return {
      pushLoading: false,
      columns: [
        {
          label: 'shebeimingcheng',
          prop: 'equipmentInfo.name'
        },
        {
          label: 'kaishigongdanhao',
          prop: 'startWoInfo.no'
        },
        {
          label: 'jieshugongdanhao',
          prop: 'endWoInfo.no'
        },
        {
          label: 'zantingkaishishijian',
          prop: 'pauseStartTime',
          type: 'time'
        },
        {
          label: 'zantingjieshuishijian',
          prop: 'pauseEndTime',
          type: 'time'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  },
  methods: {
  }
};
</script>
